import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yz-no-data-mask',
  template: `
    <table class="yz-no-data-box">
      <tr>
        <td>
          <table>
            <tr>
              <td>
                <img src="./assets/imgs/zwsj.png">
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `,
  host: {
    'class': 'yz-no-data-mask'
  },
  styleUrls: ['./yz-no-data-mask.component.less']
})
export class YzNoDataMaskComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
